export const formatPatientName = (record) => {
    const parts = [record?.firstName, record?.lastName].filter(Boolean);
    const fullName = parts.join(' ').trim() || 'Unknown Patient';
    const preferredName = record?.preferredName?.trim();

    if (!preferredName) {
        return fullName;
    }

    return `${fullName} (${preferredName})`;
};

export const formatAppointmentDate = (dateValue) => {
    if (!dateValue) {
        return '—';
    }

    const date = new Date(`${dateValue}T00:00:00`);
    if (Number.isNaN(date.getTime())) {
        return dateValue;
    }

    return date.toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

export const formatAppointmentDateTime = (record) => {
    const dateLabel = formatAppointmentDate(record?.dateAppointment);
    const startTime = record?.startTime?.trim();

    if (dateLabel === '—' && !startTime) {
        return '—';
    }

    if (!startTime) {
        return dateLabel;
    }

    if (dateLabel === '—') {
        return startTime;
    }

    return `${dateLabel} · ${startTime}`;
};

export const getRowKey = (record) => record.appointmentId || record.id;
